import { Schooladvies } from '@models/schooladvies.model';

 
export namespace SchooladviezenActions {
  export class ReadSchooladviezen {
    static readonly type = '[Schooladviezen] Read Schooladviezen';
  }

  export class ReadSchooladviezenSuccess {
    static readonly type = '[Schooladviezen] Read Schooladviezen Success';
    constructor(public schooladviezen: Schooladvies[]) {}
  }

  export class ReadSchooladviezenFailure {
    static readonly type = '[Schooladviezen] Read Schooladviezen Failure';
    constructor(public error: string) {}
  }

}
